module.exports = __webpack_public_path__ + "img/content-yellow.58a32210.svg";